<div class="w-100 file-preview-wrapper">
    <div class="file-preview">
        <span>
            {{file.name}} ({{file.type}})
        </span>
        <i class="material-icons cursor" *ngIf="removable" (click)="_remove($event)">close</i>
    </div>
</div>